import { Model } from '@vuex-orm/core'
import { REG_EXP } from '@/lib/constants'
import Reaction from '@/store/models/Reaction'

export default class PrivateChatPost extends Model {
  static entity = 'privateChatPosts'

  static primaryKey = 'id'

  static fields() {
    return {
      id: this.attr(null),
      content: this.string(''),
      privateChatId: this.attr(null),
      userId: this.attr(null),
      createdAt: this.string(''),
      updatedAt: this.string(''),
      user: this.attr(null),
      privateChatAttachmentsAttributes: this.attr([]),
      privateChatReactions: this.attr([])
    }
  }

  static permitAttributes = [
    'content',
    'privateChatAttachmentsAttributes'
  ]

  static skeleton() {
    return Object.fromEntries(
      Object.entries(this.fields())
      .map(([_, object]) => [_, object.value])
      .filter(([key]) => this.permitAttributes.includes(key))
    )
  }

  static rollbackAttachmentsById(id) {
    const currentPrivateChatPost = this.find(id)
    if (!currentPrivateChatPost) return
    this.update({
      id: id,
      privateChatAttachmentsAttributes: currentPrivateChatPost.privateChatAttachmentsAttributes.filter(attachment => attachment.id)
                                                                                               .map(attachment => {
                                                                                                 return Object.assign(attachment, {
                                                                                                   _destroy: false
                                                                                                 })
                                                                                               })
    })
  }

  /**
   * computedReactions()
   * groupChatReactionsからreactionIdの重複を検索
   * userIdをuserIdsとして配列に格納
   * reaction数はuserIdsのlengthで判定
   */
  computedReactions() {
    return this.privateChatReactions.reduce((acc, obj) => {
      const index = acc.findIndex(reaction => { return reaction.reactionId == obj.reactionId })
      if (index != -1) {
        acc[index].userIds.push(obj.userId)
        acc[index].master = Reaction.find(obj.reactionId)
      } else {
        obj.userIds = [obj.userId]
        obj.master = Reaction.find(obj.reactionId)
        acc.push(obj)
      }
      return acc
    }, [])
  }

  get linkPreviews() {
    return (this.content.match(REG_EXP.url) || []).filter((x, i, self) => {
      return self.indexOf(x) === i;
    })
  }
}
